import Fill from "./fill";
import Model from "./model";
import DashPattern from "./DashPattern";
import ApiBorder, { BorderPosition } from "../api/model/snapshots/layers/Border";
import IndividualThickness from "./IndividualThickness";
import { VariableReference } from "../api/model/variables/Variables";

export default class Border extends Model {
    fill: Fill;
    position: BorderPosition;
    thickness: number;
    individualThickness?: IndividualThickness;
    dashPattern?: DashPattern;
    variableReferences?: VariableReference[];

    constructor({
        fillType,
        color,
        gradient,
        position,
        thickness,
        individualThickness,
        opacity,
        blendMode,
        dashPattern,
        variableReferences
    }: ApiBorder) {
        super();

        this.fill = new Fill({
            fillType,
            color,
            gradient,
            opacity,
            blendMode
        });
        this.position = position;
        this.thickness = thickness;
        this.variableReferences = variableReferences;

        if (individualThickness) {
            this.individualThickness = new IndividualThickness(individualThickness);
        }

        if (dashPattern) {
            this.dashPattern = new DashPattern(dashPattern);
        }
    }

    override toObject(): ApiBorder {
        const borderObj: ApiBorder = {
            position: this.position,
            thickness: this.thickness,
            individualThickness: this.individualThickness?.toObject(),
            fillType: this.fill.type,
            opacity: this.fill.opacity,
            blendMode: this.fill.blendMode,
            dashPattern: this.dashPattern?.toObject(),
            variableReferences: this.variableReferences
        };

        if (this.fill.color) {
            borderObj.color = this.fill.color.toObject();
        } else if (this.fill.gradient) {
            borderObj.gradient = this.fill.gradient.toObject();
        }

        return borderObj;
    }
}
